export const testimonials = [
  {
    id: 1,
    name: "James & Caroline Thornton",
    role: "High Net Worth Investors, London",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20professional%20couple%20portrait%2C%20warm%20natural%20light%2C%20soft%20background%2C%20business%20casual%20attire%2C%20confident%20expression&width=80&height=80&seq=20&orientation=squarish",
    review: "Thorpe Dellow presented a compelling structured product with a clear, transparent structure. The monthly income has been consistent since day one, and the team is incredibly responsive. A refreshingly straightforward investment.",
    rating: 5,
  },
  {
    id: 2,
    name: "George Whitfield",
    role: "Sophisticated Investor, Birmingham",
    avatar: "https://readdy.ai/api/search-image?query=professional%20man%20portrait%2C%20business%20attire%2C%20warm%20light%2C%20friendly%20confident%20expression%2C%20soft%20blurred%20background&width=80&height=80&seq=21&orientation=squarish",
    review: "The social housing sector offers exactly the kind of long-term, government-backed stability I was looking for. Thorpe Dellow made the onboarding process seamless and the documentation was thorough and clear.",
    rating: 5,
  },
  {
    id: 3,
    name: "Diana Ashford",
    role: "Certified HNW Investor, Edinburgh",
    avatar: "https://readdy.ai/api/search-image?query=professional%20woman%20investor%20portrait%2C%20warm%20background%2C%20natural%20light%2C%20business%20smart%20attire%2C%20confident%20friendly%20expression&width=80&height=80&seq=22&orientation=squarish",
    review: "I appreciate that Thorpe Dellow is upfront about the risks — the IM is comprehensive and honest. The underlying asset security and independent trustee structure gave me the confidence to invest a substantial sum.",
    rating: 5,
  },
  {
    id: 4,
    name: "Robert & Susan Clarke",
    role: "Portfolio Investors, Manchester",
    avatar: "https://readdy.ai/api/search-image?query=mature%20professional%20couple%20portrait%2C%20warm%20tone%2C%20soft%20light%2C%20friendly%20natural%20expression%2C%20business%20casual&width=80&height=80&seq=23&orientation=squarish",
    review: "The 10% per annum target has proven reliable in our experience. What sets Thorpe Dellow apart is their commitment to communication — monthly statements arrive without fail, and any queries are resolved same day.",
    rating: 5,
  },
  {
    id: 5,
    name: "Victoria Hargreaves",
    role: "Self-Certified Sophisticated Investor, Bristol",
    avatar: "https://readdy.ai/api/search-image?query=professional%20young%20woman%20investor%20portrait%2C%20bright%20light%2C%20smart%20background%2C%20warm%20tones%2C%20relaxed%20confident%20expression&width=80&height=80&seq=24&orientation=squarish",
    review: "I was impressed by the social impact alongside the financial return. Knowing my capital is helping fund assisted living for vulnerable adults, while earning 10% monthly, is exactly the kind of investment I was seeking.",
    rating: 5,
  },
  {
    id: 6,
    name: "Edward Blackwood",
    role: "Alternative Investment Specialist, Leeds",
    avatar: "https://readdy.ai/api/search-image?query=confident%20professional%20man%20portrait%2C%20smart%20jacket%2C%20warm%20background%2C%20professional%20headshot%2C%20friendly%20smile%2C%20finance%20industry&width=80&height=80&seq=25&orientation=squarish",
    review: "Having reviewed many structured products in the alternative space, Thorpe Dellow's offering stands out for its robust security structure and the quality of the underlying housing association covenant. Highly credible.",
    rating: 5,
  },
];
